app.mediator.registerModule(MODULE_NAME__CONFIRM_ENTRY_CANCEL, function (app) {

    // "Private class" variables
    var modal;
    var helpers;

    return {

        modalTitle: 'Cancel submission',
        modalCloseText: 'Close',
        modalSubtitle: 'Unnamed project',

        //==========================================================xdiv2====
        // Start and stop
        //===================================================================

        onLoaded: function (data) {
            if (data.hasJustLoaded(RESOURCE_NAME__DOM)) {
                this.init();
            }
        },

        init: function () {

            modal = app.ui.uiPlugins.modal;
            helpers = app.helpers.funcs;
            this.addDomListeners();
            this.addMediatorListeners();
			
        },

        //==========================================================xdiv2====
        // Mediator event listeners
        //===================================================================

        addDomListeners: function () {

            modal.getMainModalElem().on('click', '.li-continue-editing', function (e) {
                e.preventDefault();
                modal.hide();
            });
            modal.getMainModalElem().on('click', '.li-go-to-dashboard', function (e) {
                app.helpers.funcs.addLoadIndicatorToButton(modal.getMainModalElem().find('.li-go-to-dashboard'));
            });
        },

        //==========================================================xdiv2====
        // Mediator event listeners
        //===================================================================

        addMediatorListeners: function () {

            var scope = this;

            app.mediator.addListener(EVENT_NAME__ENTER_FORM__CANCEL_PRESSED, function (data) {
                if (!data.buttonIsDisabled) {
                    scope.showModal();
                }
            }, this);
        },
		
        //==========================================================xdiv2====
        // Module
        //===================================================================

        // -----------------------------------------------
        // Set language strings
        // -----------------------------------------------

        setTitle: function(title) {
            this.modalTitle = title;
        },

        setSubTitle: function (title) {
            this.modalSubtitle = title;
        },

        setCloseButtonText: function (text) {
            this.modalCloseText = text;
        },

        // -----------------------------------------------
        // Misc
        // -----------------------------------------------

        showModal: function ($cardElem) {
            modal.addModalClass('confirm-entry-modal confirm-entry-cancel-modal', true);
            modal.setSize('md');
            modal.setCloseButtonText(this.modalCloseText);
            modal.setTitle(this.modalTitle);
            modal.setSubTitle(this.modalSubtitle);
            modal.setBodyHtml(this.getBodyHtml() + this.getBtnsHtml());
            modal.show();
        },

        hideModal: function () {
            modal.hide();
        },

        getBodyHtml: function() {
            return '<div class="confirm-entry-body tub">' + $('#confirm-entry-cancel-body-template').html() + '</div>';
        },

        getBtnsHtml: function () {
            return $('#confirm-entry-cancel-buttons-template').html();
        }
	};
});
